export const levelIdsByNumber = (
  treeLevels: readonly { id: number }[],
  requestedLevels: readonly number[],
  levelIdByNumber: readonly string[]
): readonly string[] | null => {
  const levels =
    treeLevels.length > 0
      ? [...treeLevels].sort((a, b) => a.id - b.id)
      : requestedLevels.map((id) => ({ id }));
  const levelIds = levels.flatMap((level) => {
    const levelId = levelIdByNumber[level.id - 1];
    return levelId === undefined ? [] : [levelId];
  });
  return levelIds.length === levels.length ? levelIds : null;
};
